import { render } from "./modal-reset-password.vue?vue&type=template&id=5095f029&scoped=true"
import script from "./modal-reset-password.vue?vue&type=script&lang=js"
export * from "./modal-reset-password.vue?vue&type=script&lang=js"

import "./modal-reset-password.vue?vue&type=style&index=0&id=5095f029&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5095f029"],['__file',"src/components/admin-dashboard/modals/modal-reset-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5095f029"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5095f029', __exports__)) {
    api.reload('5095f029', __exports__)
  }
  
  module.hot.accept("./modal-reset-password.vue?vue&type=template&id=5095f029&scoped=true", () => {
    api.rerender('5095f029', render)
  })

}


export default __exports__